import { SET_RESTAURANT_LANGUAGES } from "../restaurant/constants";

const initState = [];

export default function restaurantLanguageReducer(state = initState, action) {
  switch (action.type) {
    case SET_RESTAURANT_LANGUAGES:

      return action.payload;

    default:
      return state;
  }
}
